import config from '../../../config';
import { Guid } from '../../../types';

const baseUrl = `${config.apiUrl()}/Statements`;

export default {
  getStatementPaymentLinkUrl: (id: Guid): string => `${baseUrl}/${id}/pay`,
};
